import { AttachmentResponseDto } from '@issuemanager/api-client';
import { ExtendedTypography } from '@issuemanager/apps/client/components';
import { useDownloadAttachment } from '@issuemanager/apps/client/hooks';
import {
  useAtlasSemanticThemeTokens,
  WithTheme,
} from '@issuemanager/apps/client/theme';
import { bytesToKB } from '@issuemanager/apps/client/utils';
import { Link, LinkProps, Stack, styled } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';

import { TimelineEventTypography } from './timeline-event-typography';

type Props = {
  attachments: (AttachmentResponseDto & {
    deleted?: boolean;
  })[];
};

export const StyledLink = styled(Link)<WithTheme<LinkProps>>(({ theme }) => ({
  cursor: 'pointer',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.fontSize,
}));

export function IssueTimelineAttachmentsEvents({ attachments }: Props) {
  const semantic = useAtlasSemanticThemeTokens();
  const { t } = useTranslation('issue');
  const downloadAttachment = useDownloadAttachment();
  const handleDownloadAttachment = (file: AttachmentResponseDto): void => {
    downloadAttachment({
      hbDriveId: file.hbDriveId,
      name: file.name,
    });
  };

  return (
    <Stack>
      {attachments.map((attachment) => (
        <Stack
          key={attachment.id}
          direction='row'
          spacing={1}
          alignItems='center'
        >
          <Stack direction='row' spacing={1 / 2} alignItems='center'>
            {attachment.deleted ? (
              <ExtendedTypography
                color={semantic.color.text.muted.value}
                fontWeight={semantic.fontWeight.link.value}
                fontSize={semantic.fontSize.text.sm.value}
              >
                {attachment.name}
              </ExtendedTypography>
            ) : (
              <StyledLink onClick={() => handleDownloadAttachment(attachment)}>
                {attachment.name}
              </StyledLink>
            )}
            <TimelineEventTypography>
              <Trans
                t={t}
                i18nKey={
                  attachment.deleted
                    ? t('comment.attachments.deleted')
                    : t('comment.attachments.attached')
                }
                values={{
                  size: bytesToKB(attachment.size),
                }}
              />
            </TimelineEventTypography>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}
